import React from "react";
import { useNavigate } from "react-router-dom";
import metting from '../../assets/img/metting.svg'

const Start = ({ onPrevious, onNext, onSkip, question, answer }) => {

    return (
        <div className="content_box">
            <div className="form-card">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <div className="cus_img basic_sec">
                            <img src={metting} alt="Meeting" />
                            <p>{question} will start now</p>
                        </div>
                    </div>

                    <div className="col-md-12 mt-4 text-center">
                        <div className="next_btn">
                            <button
                                name="next"
                                className="custom_back"
                                onClick={onPrevious}
                            >
                                Back
                            </button>
                            <button
                                name="next"
                                className="custom mt-0"
                                onClick={() => { onNext(); }}
                            >
                                Click to Start
                            </button>
                            {answer && <p className="skip">
                                <a href="#" onClick={onSkip}>
                                    Skip to {answer}
                                </a>
                            </p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Start;